export default "__VITE_ASSET__CLGD$T$r__"